<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Pengaturan Akun</h5>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="row g-4">
              <div class="col-sm-7 col-lg-8 order-2 order-sm-1">
                <ul class="nav nav-pills mb-4 gap-1" id="pills-tab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="pills-0-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-0"
                      type="button"
                      role="tab"
                      aria-controls="pills-0"
                      aria-selected="true"
                    >Biodata dan Akun</button>
                  </li>
                  <!-- <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="pills-1-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-1"
                        type="button"
                        role="tab"
                        aria-controls="pills-1"
                        aria-selected="false"
                      >Akun</button>
                  </li>-->
                  <li
                    v-if="type == 'admin' && user_login.id != ''"
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      class="nav-link"
                      id="pills-2-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-2"
                      type="button"
                      role="tab"
                      aria-controls="pills-2"
                      aria-selected="false"
                    >Spesialisasi</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="pills-3-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-3"
                      type="button"
                      role="tab"
                      aria-controls="pills-3"
                      aria-selected="false"
                    >Jadwal Praktik</button>
                  </li>
                </ul>

                <div class="tab-content" id="pills-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="pills-0"
                    role="tabpanel"
                    aria-labelledby="pills-0-tab"
                    tabindex="0"
                  >
                    <form @submit.prevent="onSubmit">
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Nama Lengkap *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            v-model="form.fullname"
                            class="form-control"
                            placeholder="Nama Lengkap..."
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">NIK / Nomor Penduduk *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            v-model="form.nik"
                            class="form-control"
                            placeholder="NIK / Nomor Penduduk..."
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Tanggal Lahir</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="date"
                            v-model="form.birth_date"
                            class="form-control"
                            value
                            placeholder="Tanggal Lahir..."
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Jenis Kelamin *</label>
                        </div>
                        <div class="col-lg-8">
                          <div class="form-check form-check-inline">
                            <input
                              v-model="form.gender"
                              class="form-check-input"
                              type="radio"
                              name="gender"
                              id="inlineRadio1"
                              value="male"
                              autocomplete="off"
                              required
                            >
                            <label class="form-check-label" for="inlineRadio1">Pria</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              v-model="form.gender"
                              class="form-check-input"
                              type="radio"
                              name="gender"
                              id="inlineRadio2"
                              value="female"
                              autocomplete="off"
                            >
                            <label class="form-check-label" for="inlineRadio2">Wanita</label>
                          </div>
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Usia</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            v-model="usia"
                            type="number"
                            class="form-control"
                            placeholder="Usia..."
                            min="1"
                            max="200"
                            autocomplete="off"
                            disabled
                          >
                        </div>
                      </div>

                      <hr class="border-0 pt-1 bg-dark rounded my-4">

                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Alamat</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            v-model="form.address"
                            class="form-control"
                            placeholder="Alamat..."
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Provinsi</label>
                        </div>
                        <div class="col-lg-8">
                          <select
                            v-model="form.province"
                            @change="getCity()"
                            type="text"
                            class="form-select"
                          >
                            <option value disabled hidden>--- Pilih ---</option>
                            <option
                              v-for="(item,i) in provinceList"
                              :value="item.name"
                              :key="`p${i}`"
                            >{{ item.name }}</option>
                          </select>

                          <!-- <input
                            type="text"
                            id
                            class="form-control"
                            value
                            placeholder="Provinsi..."
                            autocomplete="off"
                          >-->
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Kota</label>
                        </div>
                        <div class="col-lg-8">
                          <select v-model="form.city" type="text" class="form-select">
                            <option value disabled hidden>--- Pilih ---</option>
                            <option
                              v-for="(item,it) in cityList"
                              :value="item.name"
                              :key="`ct${it}`"
                            >{{ item.name }}</option>
                          </select>
                          <!-- <input
                            type="text"
                            id
                            class="form-control"
                            value
                            placeholder="Kota..."
                            autocomplete="off"
                          >-->
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Kode Pos</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="number"
                            v-model="form.postal_code"
                            class="form-control"
                            placeholder="Kode Pos..."
                            autocomplete="off"
                          >
                        </div>
                      </div>

                      <hr class="border-0 pt-1 bg-dark rounded my-4">

                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Alamat Email *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="email"
                            v-model="form.email"
                            class="form-control"
                            placeholder="Alamat Email..."
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Nomor Telepon *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="number"
                            v-model="form.telp"
                            class="form-control"
                            placeholder="Nomor Telepon..."
                            min="0"
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>
                      <div v-if="type == 'admin'" class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Role Akun *</label>
                        </div>
                        <div class="col-lg-8">
                          <span class="badge text-bg-success">{{form.type}}</span>
                        </div>
                      </div>
                      <button
                        type="submit"
                        class="btn btn-primary mt-4 liveToastBtn"
                      >{{button}} Biodata</button>
                    </form>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="pills-1"
                    role="tabpanel"
                    aria-labelledby="pills-1-tab"
                    tabindex="0"
                  ></div>

                  <div
                    class="tab-pane fade"
                    id="pills-2"
                    role="tabpanel"
                    aria-labelledby="pills-2-tab"
                    tabindex="0"
                  >
                    <div class="row g-0 g-lg-3 align-items-center mb-3">
                      <div class="col-lg-4">
                        <label for class="col-form-label">Spesialisasi</label>
                      </div>
                      <div class="col-lg-8">{{form2.spesialization}}</div>
                    </div>
                    <div class="row g-0 g-lg-3 align-items-center mb-3">
                      <div class="col-lg-4">
                        <label for class="col-form-label">Nomor Lisensi (SIP)</label>
                      </div>
                      <div class="col-lg-8">{{form2.licence_number}}</div>
                    </div>
                    <div class="row g-0 g-lg-3 align-items-center mb-3">
                      <div class="col-lg-4">
                        <label for class="col-form-label">Deskripsi Profil</label>
                      </div>
                      <div class="col-lg-8">{{form2.description}}</div>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="pills-3"
                    role="tabpanel"
                    aria-labelledby="pills-3-tab"
                    tabindex="0"
                  >
                    <div
                      v-for="(hari, idx) in form2.clinical_schedule"
                      :key="idx"
                      class="row g-2 align-items-center mb-3"
                    >
                      <div class="col-3 col-lg-2 col-xxl-1">
                        <label for class="form-label text-nowrap m-0">{{ hari.day }}</label>
                      </div>
                      <div class="col-auto">:</div>
                      <div class="col-auto d-flex align-items-center gap-1">
                        <div>
                          <span class="badge border text-bg-light">{{hari.time_1.start}}</span>
                        </div>-
                        <div>
                          <span class="badge border text-bg-light">{{hari.time_1.end}}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- ================================== -->
                  <!-- form kejiwaan -->
                  <!-- ================================== -->
                </div>
              </div>

              <div v-if="user_login.id" class="col-sm-5 col-lg-3 order-1 order-sm-2">
                <div class="bg-success-subtle rounded-4 p-2 shadow-sm mb-3 text-center">
                  <img
                    v-if="preview != ''"
                    :src="preview"
                    alt="preview"
                    class="img-fluid rounded-3"
                  >
                  <img
                    v-else-if="preview == ''"
                    src="../assets/images/profile/user-7.jpg"
                    class="img-fluid rounded-3"
                    alt="no-img"
                  >
                  <img v-else :src="preview" alt="preview" class="img-fluid rounded-3">
                </div>

                <button @click="triggerFileInput" class="btn btn-success w-100 rounded">Upload Image</button>
                <input type="file" @change="onFileChange" ref="fileInput" style="display: none">
              </div>
            </div>

            <!-- <button
              type="submit"
              href="detail-examination.php"
              class="btn btn-primary mt-4 liveToastBtn"
            >Simpan</button>-->
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import config from "../config";

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			user_login: JSON.parse(localStorage.getItem('user_login')).data,
			token: localStorage.getItem('token'),
			form: {
				// id: '',
				fullname: '',
				name: '',
				type: 'nurse',
				email: '',
				password: '',
				birth_date: '1990-12-30',
				telp: '',
				gender: 'female',
				roleId: 3,
				statusId: 1,
				nik: '',
				place_date: '',
				address: '',
				city: '',
				province: '',
				country: 'ID',
				religion: '',
				specialization: '',
				licence_number: ''
			},
			form2: {
				spesialization: '',
				licence_number: '',
				description: '',
				clinical_schedule: [
					{
						day: 'Senin',
						time_1: {
							start: '',
							end: ''
						}
					},
					{
						day: 'Selasa',
						time_1: {
							start: '',
							end: ''
						}
					},
					{
						day: 'Rabu',
						time_1: {
							start: '',
							end: ''
						}
					},
					{
						day: 'Kamis',
						time_1: {
							start: '',
							end: ''
						}
					},
					{
						day: 'Jumat',
						time_1: {
							start: '',
							end: ''
						}
					},
					{
						day: 'Sabtu',
						time_1: {
							start: '',
							end: ''
						}
					},
					{
						day: 'Minggu',
						time_1: {
							start: '',
							end: ''
						}
					}
				]
			},
			form3: {
				profile: '',
				description: '',
				hpht: '',
				pre_pregnancy_weight: '',
				obstetric_history: '',
				cesarean_count: '',
				medical_history: '',
				statusId: 11
			},
			file: null,
			// preview: '',
			title: 'Tambah',
			button: 'Simpan',
			url: 'users/add',
			url2: 'user_spesialized/',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		this.$store.dispatch('location/getDataThird', {
			url: `datasheet/provinces`
		})

		this.title = 'Update'
		this.button = 'Update'
		this.$store
			.dispatch('location/getDataPayload', {
				url: `users/${this.user_login.id}`
			})
			.then((res) => {
				console.log('respon->>', res)

				this.form = {
					// id: this.dataUser.id,
					fullname: this.dataUser.user_profile.fullname,
					type: this.dataUser.type,
					email: this.dataUser.email,
					// email: res.payload.email,
					// password: this.dataUser.user_profile.,
					birth_date: this.dataUser.user_profile.birth_date,
					attachment: this.dataUser.user_profile.attachment,

					postal_code: this.dataUser.user_profile.postal_code,
					gender: this.dataUser.user_profile.gender,
					telp: this.dataUser.user_profile.telp,
					roleId: this.dataUser.roleId,
					statusId: this.dataUser.statusId,
					nik: this.dataUser.user_profile.nik,
					place_date: this.dataUser.user_profile.place_date,
					address: this.dataUser.user_profile.address,
					city: this.dataUser.user_profile.city,
					province: this.dataUser.user_profile.province,
					country: 'ID',
					religion: this.dataUser.user_profile.religion,
					specialization: this.dataUser.user_profile.specialization,
					licence_number: this.dataUser.user_profile.licence_number
				}
				if (this.form.province != 'undefined' && this.form.province != '' && this.form.province != null) {
					this.getCity()
				}
			})

		this.$store
			.dispatch('location/getDataPayload3', {
				url: `user_spesialized/user/${this.user_login.id}`
			})
			.then((res) => {
				console.log('respon spea->>', res)

				if (res.payload.Records != null) {
					this.form2 = res.payload.Records
				}
			})
	},
	computed: {
		...mapGetters({
			dataUser: 'location/getDataPayload',
			dataSpeali: 'location/getDataPayload3',
			provinceList: 'location/getDataThird',
			cityList: 'location/getDataPayload2'
		}),
		preview: {
			// getter
			get() {
				let url = ''
				if (this.dataUser && this.dataUser.user_profile) {
					if (this.dataUser.user_profile.attachment === null || this.dataUser.user_profile.attachment === 'null' || this.dataUser.user_profile.attachment === undefined || this.dataUser.user_profile.attachment === 'undefined' || this.dataUser.user_profile.attachment === '') {
					} else {
						url = config("api.baseUrl") + 'storage/uploads/' + this.dataUser.user_profile.attachment
					}
				} else {
				}
				return url
			},
			set(value) {
				this.dataUser.user_profile.attachment = value
			}
		},
		usia: {
			// getter
			get() {
				return this.hitungUsia(this.form.birth_date)
			}
		},
		hpl: {
			// getter
			get() {
				return this.hitungHplDanUsia(this.form3.hpht).hpl
			}
		},
		usiaKehamilan: {
			// getter
			get() {
				return this.hitungHplDanUsia(this.form3.hpht).usiaMinggu
			}
		},
		type: {
			// getter
			get() {
				return this.$route.query.type || 'admin'
			}
		}
	},
	methods: {
		triggerFileInput() {
			this.$refs.fileInput.click() // klik input file tersembunyi
		},
		// upload khusus update user
		onFileChange(e) {
			const file = e.target.files[0]
			if (file) {
				this.file = file
				// this.preview = URL.createObjectURL(file) // buat preview gambar

				let formData = new FormData()
				formData.append('image', this.file)
				this.$store.dispatch('location/upload', formData).then((res) => {
					// this.storeData(res.filename)
					console.log('res dari api set img==>', res)
					this.preview = res.filename
					this.form.attachment = res.filename
					this.form.name = this.form.fullname
					this.$store
						.dispatch('location/createNewRecord', {
							data: this.form,
							url: 'users/update/' + this.user_login.id,
							method: 'PUT'
						})
						.then((res) => {
							console.log(res)
							let toast = this.$toasted.show(`${res.msg}`, {
								theme: 'bubble',
								position: 'top-right',
								duration: 3000
							})
						})
				})
			}

			// if (!this.file) {
			// 	alert('Pilih gambar dulu!')
			// 	return
			// }
		},
		getCity() {
			this.$store.dispatch('location/getDataPayload2', {
				url: `datasheet/cities/${this.form.province}`
			})
		},
		onSubmit() {
			if (this.user_login.id != '') {
				this.url = 'users/update/' + this.user_login.id
				this.method = 'PUT'
			}


			this.form.name = this.form.fullname
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: this.url,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.form.id = res.payload.id
					} else {
					}
				})
		},
		hitungUsia(tanggalLahir) {
			const today = new Date()
			const birthDate = new Date(tanggalLahir)
			let age = today.getFullYear() - birthDate.getFullYear()
			const m = today.getMonth() - birthDate.getMonth()

			// kalau bulan belum lewat, atau bulan sama tapi hari belum lewat → usia dikurangi 1
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--
			}

			return age
		},
		hitungHplDanUsia(hpht) {
			const hphtDate = new Date(hpht)
			if (isNaN(hphtDate)) {
				return { error: 'Format tanggal salah (gunakan YYYY-MM-DD)' }
			}

			// --- HPL (HPHT + 280 hari) ---
			const hplDate = new Date(hphtDate)
			hplDate.setDate(hplDate.getDate() + 280)

			// --- Usia Kehamilan ---
			const today = new Date()
			let diffMs = today - hphtDate // selisih dalam ms
			if (diffMs < 0) {
				return { error: 'HPHT tidak boleh setelah hari ini' }
			}

			let usiaHari = Math.floor(diffMs / (1000 * 60 * 60 * 24))
			let usiaMinggu = Math.floor(usiaHari / 7)
			let sisaHari = usiaHari % 7

			return {
				hpl: hplDate.toISOString().split('T')[0], // format YYYY-MM-DD
				usiaHari,
				usiaMinggu,
				keterangan: `${usiaMinggu} minggu ${sisaHari} hari`
			}
		}
		// edit(id) {
		// 	let data = this.dataList.find((o) => o.id === id)
		// 	console.log(data)
		// 	this.form = {
		// 		id: id,
		// 		location_name: data.location_name,
		// 		address: data.address,
		// 		city: data.city,
		// 		province: data.province,
		// 		postal_code: data.postal_code,
		// 		country: data.country,
		// 		email: data.email,
		// 		phone_number: data.phone_number,
		// 		map_url: data.map_url,
		// 		statusId: data.statusId
		// 	}
		// 	this.url = 'location/' + id
		// 	this.method = 'put'
		// }
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
